<template>
  <div id="survey-start-page">
    <div class="mb-2">
      <span :class="`${styles.pageTitle} indigo--text ml-2`"
        ><strong>{{ $t("설문 완료 요청") }}</strong></span
      >
    </div>
    <v-card
      :class="`${
        $vuetify.breakpoint.smAndDown ? 'elevation-0' : 'elevation-10'
      }`"
    >
      <!-- 설문 완료 요청 페이지 타이틀 START -->
      <v-card-title primary-title class="justify-left">
        <span :class="styles.header"
          ><strong>{{ properties.survey.surveyEndTitle }}</strong></span
        >
      </v-card-title>
      <!-- 설문 완료 요청  페이지 타이틀 END -->
      <v-divider></v-divider>
      <!-- 설문 완료 요청  페이지 설명 START -->
      <v-card-text class="justify-center mt-4">
        <pre :class="`${styles.description} mx-4`">{{
          properties.survey.surveyEndDescription
        }}</pre>
      </v-card-text>
      <!-- 설문 완료 요청  페이지 설명 END -->
      <!-- 액션 영역 START -->
      <v-card-actions class="mt-10">
        <v-spacer></v-spacer>
        <v-btn
          v-if="canMovePrevious"
          width="140"
          max-width="300"
          large
          class="text-h6 mb-4 rounded-lg mr-2"
          @click="$emit('previous')"
          ><strong>{{ $t("이전") }}</strong></v-btn
        >
        <v-btn
          width="140"
          max-width="300"
          large
          :color="themeColor"
          dark
          class="text-h6 mb-4 rounded-lg"
          @click="submitSurvey"
          ><strong>{{ properties.survey.surveyEndButton }}</strong></v-btn
        >
        <v-spacer></v-spacer>
      </v-card-actions>
      <!-- 액션 페이지 타이틀 END -->
    </v-card>
  </div>
</template>

<script>
import { $submitSurvey } from "@/redsurvey/api/survey";
export default {
  props: {
    properties: {
      type: Object,
    },
    rid: {
      type: String,
      required: true,
    },
    targetKey: {
      type: String,
    },
    isPreview: {
      type: Boolean,
      default: false,
    },
    pagePath: {
      type: Array,
      default: () => [],
    },
    themeColor: {
      type: String,
      default: "primary",
    },
  },
  computed: {
    canMovePrevious() {
      if (this.isPreview) {
        // 미리보기는 부모가 메모리에서 관리하는 경로를 사용
        return this.pagePath.length > 0;
      } else {
        // 실제 설문은 RS_SURVEY_RESPONSE.PAGE_PATH를 사용
        return (
          JSON.parse(this.properties.surveyResponse.pagePath || "[]").length > 0
        );
      }
    },
    styles() {
      switch (this.$vuetify.breakpoint.name) {
        case "xs":
          return {
            pageTitle: "text-h6",
            header: "text-subtitle-1",
            description: "text-subtitle-1 content-description mx-5",
          };
        default:
          return {
            pageTitle: "text-h5",
            header: "text-h6",
            description: "text-subtitle-1 content-description mx-5",
          };
      }
    },
  },
  methods: {
    async submitSurvey() {
      this.$emit("loading", true);
      try {
        const params = {
          k: this.targetKey,
          r: this.rid,
        };
        const surveyId = this.properties.survey.surveyId;

        if (this.isPreview) {
          this.$emit("next", "COMPLETED");
        } else {
          const { data } = await $submitSurvey(surveyId, params);
          this.$emit("next", data.result);
        }
      } catch (e) {
        this.$rxSnackbar("error", this.$t("common.msg.unexpected_error"));
      } finally {
        this.$emit("loading", false);
      }
    },
  },
};
</script>

<style lang="scss" scoped>
.content-description {
  white-space: pre-wrap;
}
</style>